<template>
  <v-container class="pa-5">
    <v-card class="pa-3">
      <v-card-text class="text-center">
        <v-avatar size="40" color="green">
          <v-icon size="30" color="white">mdi-check</v-icon>
        </v-avatar>
        <div class="subtitle-1 mt-5 font-weight-regular black--text">
          {{ isAllNoResponse ? 'Konfirmasi' : 'Jawaban Terkirim' }}
        </div>
        <div>
          {{ isAllNoResponse ? 'Terima kasih atas perhatian Anda' : 'Jawaban Anda telah kami simpan, Terima kasih atas respon Anda' }}
        </div>
        <div class="white--text">
          kuesioner_success
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  computed: {
    isAllNoResponse() {
      return Number(this.$route.query.info_only) === 1
    }
  },
  mounted() {
    setTimeout(() => {
      if (window && window.webkit) {
        window.webkit.messageHandlers.bridge.postMessage('kuesioner_success')
      }
    }, 1000)
  },
}
</script>
